import { QUESTION_TYPES } from "../../../utils/surveysConstants";

const renderAnswerPreview = (question) => {
  switch (question.type) {
    case QUESTION_TYPES.SHORT_TEXT:
      return (
        <input
          type="text"
          disabled
          aria-label={question.label || "Response"}
          placeholder="Participant response"
        />
      );
    case QUESTION_TYPES.LONG_TEXT:
      return (
        <textarea
          rows={3}
          disabled
          aria-label={question.label || "Response"}
          placeholder="Participant response"
        />
      );
    case QUESTION_TYPES.NUMERIC:
      return (
        <input
          type="number"
          disabled
          aria-label={question.label || "Response"}
          placeholder="0"
          style={{ maxWidth: "140px" }}
        />
      );
    case QUESTION_TYPES.DROPDOWN:
      return (
        <select disabled defaultValue="" aria-label={question.label || "Select an option"}>
          <option value="" disabled>Select...</option>
          {(question.options || []).map((opt) => (
            <option key={opt}>{opt}</option>
          ))}
        </select>
      );
    case QUESTION_TYPES.YES_NO:
      return (
        <div className="survey-preview_choices">
          {["Yes", "No"].map((opt) => (
            <label key={opt}><input type="radio" disabled name={`q-${question.id}`} /> {opt}</label>
          ))}
        </div>
      );
    case QUESTION_TYPES.SINGLE_CHOICE:
      return (
        <div className="survey-preview_choices">
          {(question.options || []).map((opt) => (
            <label key={opt}><input type="radio" disabled name={`q-${question.id}`} /> {opt}</label>
          ))}
        </div>
      );
    case QUESTION_TYPES.MULTI_CHOICE:
      return (
        <div className="survey-preview_choices">
          {(question.options || []).map((opt) => (
            <label key={opt}><input type="checkbox" disabled /> {opt}</label>
          ))}
        </div>
      );
    case QUESTION_TYPES.RATING: {
      const min = Number.isFinite(question.scaleMin) ? question.scaleMin : 1;
      const max = Number.isFinite(question.scaleMax) ? question.scaleMax : 5;
      const steps = [];
      for (let n = min; n <= max; n++) steps.push(n);
      return (
        <div className="survey-preview_scale">
          {steps.map((n) => (
            <label key={n} className="survey-preview_scale_item">
              <input type="radio" disabled name={`q-${question.id}`} />
              <span>{n}</span>
            </label>
          ))}
        </div>
      );
    }
    default:
      return null;
  }
};

// Live, read-only rendering of the survey as a patient would see it — pure
// function of formData, no separate preview state to keep in sync.
const SurveyPreviewPane = ({ formData }) => {
  return (
    <div className="survey-builder_preview">
      <h4>Participant Preview</h4>
      <p className="survey-builder_palette_hint">Preview the survey as a Participant User.</p>

      <div className="survey-preview_body">
        {formData.studyName && <div className="survey-preview_eyebrow">{formData.studyName.toUpperCase()}</div>}
        <h2 className="survey-preview_title">{formData.title || "Untitled Survey"}</h2>
        {formData.description && <p className="survey-preview_instructions">{formData.description}</p>}
        <div className="survey-preview_meta">Version {formData.version || "1.0"}</div>

        <hr />

        {formData.questions.map((question) => {
          if (question.type === QUESTION_TYPES.SECTION) {
            return (
              <div key={question.id} className="survey-preview_section">
                {question.label || "Untitled Section"}
              </div>
            );
          }
          if (question.type === QUESTION_TYPES.INSTRUCTION) {
            return (
              <p key={question.id} className="survey-preview_instruction-text">
                {question.label}
              </p>
            );
          }
          return (
            <div key={question.id} className="survey-preview_question">
              <div className="survey-preview_question_label">
                {question.label || "Untitled question"}
                {question.required && <span className="survey-preview_required">*</span>}
              </div>
              {renderAnswerPreview(question)}
              {question.helpText && <div className="survey-preview_help">{question.helpText}</div>}
            </div>
          );
        })}

        <button type="button" className="survey-preview_submit" disabled>Complete Survey</button>
        <div className="survey-preview_footnote">
          Builder preview only. Assignment is required before a real patient submission is saved.
        </div>
      </div>
    </div>
  );
};

export default SurveyPreviewPane;
